import { render, staticRenderFns } from "./CreatePopOrderCard.vue?vue&type=template&id=48aa13c9&"
import script from "./CreatePopOrderCard.vue?vue&type=script&lang=js&"
export * from "./CreatePopOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./CreatePopOrderCard.vue?vue&type=style&index=0&id=48aa13c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports